import './integration.scss'

import { API, Card, Table, ViewHeader, useGet } from '@enkla-gui'
import React, { useEffect, useState } from 'react'

export default function Integration() {
  const [integrations, setIntegrations] = useState(false)
  const { data: companies } = useGet({ endpoint: 'api/company' })

  const getIntegrations = () => {
    API.get('api/integration').then(integrations => setIntegrations(integrations))
  }

  useEffect(() => {
    getIntegrations()
  }, [])

  const getConnectedCount = (integrationId) => {
    if (!companies?.data) return 0
    return companies.data.filter(c => c.invoicingconfig?.integration_id === integrationId).length
  }

  return (
    <>
      <ViewHeader
        icon='fa-puzzle-piece'
        title='Integrationer'
        subtitle='Översikt'
      />

      {companies?.data?.length > 0 && (
        <div className="integration-quicklinks">
          <div className="integration-quicklinks__info">
            <i className="fas fa-info-circle" />
            <span>För att få tillgång till en faktura-integration behöver du välja den som metod i aviseringsinställningarna för företaget.</span>
          </div>
          <div className="integration-quicklinks__bottom">
            <div className="integration-quicklinks__label">
              <i className="fas fa-building" />
              Snabblänkar:
            </div>
            <div className="integration-quicklinks__links">
              {companies.data.map(c => (
                <a key={c.id} href={`#!/company/${c.id}/invoicingconfig`} className="integration-quicklinks__link">
                  {c.name}
                  <i className="fas fa-arrow-right" />
                </a>
              ))}
            </div>
          </div>
        </div>
      )}

      <Card loading={!integrations} title='Integrationer' icon='fas fa-plug'>
        <Table
          rows={integrations}
          link='/#!/integration/@{id}'
          empty={{ text: 'Du har inte kopplat någon integration', icon: 'fas fa-plug' }}
          functions={{
            status: token_invalid => (
              <span className={`badge bg-${token_invalid ? 'danger' : 'success'}`}>
                {token_invalid ? 'Behöver anslutas på nytt' : 'Ansluten'}
              </span>
            ),
            companies: integration => {
              if (integration.name === 'FASDOK') return '-'
              const count = getConnectedCount(integration.id)
              return <span className={count > 0 ? 'text-success' : 'text-muted'}>{count} företag</span>
            }
          }}
          keys={['token_invalid>function:status','nice_name', 'description', '_this>function:companies',  'created_at>date:full']}>
          <th className='min'>Status</th>
          <th className='min'>Integration</th>
          <th>Beskrivning</th>
          <th className='min'>Anslutna</th>
          <th className='min'>Kopplad</th>
        </Table>
      </Card>
    </>
  )
}
